// 设置变量
const state = {
    config: {}, //配置
    friendLinksList: localStorage.getItem("friendLinksList") ? JSON.parse(localStorage.getItem("friendLinksList")) : [], //友情链接
    unitList: [], //单位列表
    hotList: [], //热门搜索
}
import {getConfigByKeyPost, getDictValuesByKey, getFriendLinksList} from "@/api/modules/common.js";
// 修改 state 的唯一方式（必须是同步）
const mutations = {
    //设置配置
    SET_CONFIG(state, config) {
        state.config = config;
    },
    //设置配置
    SET_UNIT_LIST(state, unitList) {
        state.unitList = unitList;
    },
    //设置热门搜索
    SET_HOT_LIST(state, hotList) {
        state.hotList = hotList;
    },
    //设置友情链接
    SET_FRIEND_LINKS(state, friendLinksList) {
        state.friendLinksList = friendLinksList;
        localStorage.setItem('friendLinksList', JSON.stringify(friendLinksList));
    }
}
// 提交 mutation，可以包含异步操作
const actions = {
    async getDictValuesByKeyFun({commit}) {
        getDictValuesByKey({key: "product_unit"}).then((res) => {
            commit('SET_UNIT_LIST', res.data.values);
        });
    },
    async getHotList({commit}) {
        getDictValuesByKey({key: "hot_search"}).then((res) => {
            commit('SET_HOT_LIST', res.data.values);
        });
    },
    // 异步获取配置
    async getConfig({commit}) {
        try {
            const res = await getConfigByKeyPost({
                key: ['gongan_beian', 'site_mail', 'site_mible', 'site_icp', 'pay_name', 'pay_account', 'pay_bank', 'pay_alipay'
                    , 'work_time', 'vip_acount', 'svip_acount', 'mini_qrcode', 'wechat_qrcode', 'hotline', 'about_us_img', 'about_us_text', 'company_name', 'company_address', 'company_contract', 'about_us_title']
            });
            commit('SET_CONFIG', res.data.data);
            return res.data.data;
        } catch (error) {
            console.error('获取配置失败:', error);
            return null;
        }
    },
    // 异步获取友情链接
    async getFriendLinks({commit}) {
        const res = await getFriendLinksList({}, true, 1800);
        commit('SET_FRIEND_LINKS', res.data.data.data);
    }
}

export default {
    state,
    mutations,
    actions
}
